import React, { useState } from "react";
import Storage from "../../Data/Domain/Storage";
import { Title } from "../../Utils/UI/Text";
import OwnerDocumentsTable from "./documentTable";
import NewDocument from "./NewDocument";

import { getUserDocuments } from "../Application/Documents.bussines";
import User from "../../Users/Domain/User";
import Document from "../../DocumentUpload/Domain/Document";

const Documents = () => {
  const role = new Storage("rol").getItem();
  const userId = new Storage("id").getItem();
  const [description, setDescription] = useState("");
  const handleDescriptionChange = (e) => setDescription(e.target.value);

  const handleImageUpdate = async () => {
    setDescription("");
    await getUserDocuments({ userId, page: 0, limit: 10 });
  };
  const getByUser = (id) => getUserDocuments({ userId: id, page: 0, limit: 10 });

  return (
    <>
      <Title
        children="Documentos"
        childrenTwo={
          <NewDocument
            userId={userId}
            description={description}
            handleDescriptionChange={handleDescriptionChange}
            handleImageUpdate={handleImageUpdate}
            getByUser={getByUser}
            User={User}
            role={role}
            docType={Document.DOCUMENT}
          />
        }
      />

      <OwnerDocumentsTable />
    </>
  );
};

export default Documents;
